module.exports = __webpack_public_path__ + "static/index-dc76fcb805415b94f35186639a5bdbd1.png";